import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

const IST = 'Asia/Kolkata';

/** Display rupees from integer paise — never store floats. */
export function formatRupees(amountPaise: number): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
  }).format(amountPaise / 100);
}

export function formatIstDate(iso: string | Date, pattern = 'dd MMM yyyy, hh:mm a'): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  const zoned = toZonedTime(d, IST);
  return format(zoned, pattern);
}
